export enum SortTypes {
  SortDefault = 1,
  SortAscending,
  SortDescending,
}

export enum ObjectType {
  Project = 'PROJECT',
  Task = 'TASK',
}

export enum ChartType {
  Column = 'column',
  Line = 'line',
  Spline = 'spline',
}
